import { Loader2, CheckCircle2, AlertTriangle, Clock, RefreshCw } from "lucide-react";

const MAP = {
  queued: { label: "En cola", cls: "text-sky-400 border-sky-400/40 bg-sky-400/10", icon: Clock },
  processing: { label: "Generando", cls: "text-[#FF9F2E] border-[#FF9F2E]/40 bg-[#FF9F2E]/10", icon: Loader2, spin: true },
  ready: { label: "Listo", cls: "text-emerald-400 border-emerald-400/40 bg-emerald-400/10", icon: CheckCircle2 },
  failed: { label: "Error", cls: "text-red-400 border-red-400/40 bg-red-400/10", icon: AlertTriangle },
  draft: { label: "Borrador", cls: "text-slate-400 border-slate-400/30 bg-white/5", icon: Clock },
};

export default function StatusBadge({ status, retry }) {
  if (status === "processing" && retry) {
    return (
      <span className="inline-flex items-center gap-1.5 text-[0.68rem] font-mono uppercase tracking-wider px-2.5 py-1 rounded-full border text-[#FF9F2E] border-[#FF9F2E]/40 bg-[#FF9F2E]/10" data-testid="status-retry">
        <RefreshCw className="w-3 h-3 spin" />
        Reintento {retry.attempt}/{retry.max}
      </span>
    );
  }
  const s = MAP[status] || MAP.draft;
  const Icon = s.icon;
  return (
    <span className={`inline-flex items-center gap-1.5 text-[0.68rem] font-mono uppercase tracking-wider px-2.5 py-1 rounded-full border ${s.cls}`} data-testid={`status-${status}`}>
      <Icon className={`w-3 h-3 ${s.spin ? "spin" : ""}`} />
      {s.label}
    </span>
  );
}
